import { render, staticRenderFns } from "./AddTaskButton.vue?vue&type=template&id=21127351&scoped=true&"
var script = {}
import style0 from "./AddTaskButton.vue?vue&type=style&index=0&id=21127351&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21127351",
  null
  
)

export default component.exports